import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'babel-polyfill';
import { initFontSize } from './common/js/sns.js';
import '@/styles/index.less';
import jsBridge from '@/plugins/js-bridge.js';
import native from '@/plugins/native.js';
import { Lazyload, Loading } from 'vant';
import nums from './nums.js';
import '@/assets/fonts/font.css';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { reportErrors, registerSky } from '@/utils/skyWalkingConfig';
import '@vant/touch-emulator';

Vue.use(VueDOMPurifyHTML);
registerSky();
Vue.config.errorHandler = error => {
  console.error(error);
  reportErrors(error);
};
window.weblog?.setConfig({
  appKey: 'f058354df1',
});
window.showDownload = function () {
  // 客户端下载回调占位
};
Vue.prototype.$num = nums;
Vue.config.productionTip = false;
Vue.use(Lazyload);
Vue.use(Loading);
Vue.use(jsBridge);
Vue.use(native);

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    initFontSize();
    window.addEventListener('resize', initFontSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', initFontSize);
  },
}).$mount('#app');
